import { render, staticRenderFns } from "./invoice-sales-red-add-or-update.vue?vue&type=template&id=507745e1&scoped=true"
import script from "./invoice-sales-red-add-or-update.vue?vue&type=script&lang=js"
export * from "./invoice-sales-red-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./invoice-sales-red-add-or-update.vue?vue&type=style&index=0&id=507745e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507745e1",
  null
  
)

export default component.exports